/**
 * KPI figure string shared by the chat renderer. Matches
 * src/services/analysis/blocks/format.js formatNumber (and export).
 */
import { formatNumber } from '../../core/format.js';

/**
 * Prefer resolved `text`; otherwise format the raw value the same way
 * the server export does.
 * @param {object} item
 * @returns {string}
 */
export function figureText(item) {
  if (item && item.text != null && item.text !== '') return String(item.text);
  if (item && item.value != null && item.value !== '') return formatNumber(item.value);
  return '';
}

/** D2: unverified typed number tooltip (chat-blocks-v2-1-plan). */
export const UNVERIFIED_TITLE = "Not found in this turn's data";

/**
 * @param {unknown} node
 * @returns {boolean}
 */
export function isUnverified(node) {
  return !!(node && typeof node === 'object' && node.verified === false);
}
